import _ from 'underscore';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'v2-inplace-dropdown-select',
    templateUrl: './inplace-dropdown-select.component.html',
    styleUrls: ['./inplace-dropdown-select.component.scss'],
    standalone: false
})
export class InplaceDropdownSelectComponent implements OnInit {
  @Input()
  choices: any[] = ['Buy', 'Sell'];

  @Input()
  optionTemplate;

  @Output()
  selectedChange = new EventEmitter<number>();

  expanded = false;

  _selected = 0;
  @Input()
  set selected(v: number) {
    if (v === this._selected) {
      return;
    }
    this._selected = v;
    this.selectedChange.next(v);
  }
  get selected() {
    return this._selected;
  }

  get option() {
    return !_.isEmpty(this.choices) ? this.choices[this.selected] : undefined;
  }

  constructor() {}

  ngOnInit(): void {}
}
